<template>
	<div class='main'>
		<header class='main_login' id='main_Top'>
			<img :src="imgUrls+'logo_main_white.png'" alt="">
			<p>新冠肺炎科普与服务平台</p>
		</header>
		<aside class='aside_banner'>
			<van-swipe class='vanSwipe' :autoplay="3000" indicator-color="white">
				<van-swipe-item v-for="(image, index) in imgList" :key="index" v-if='image.status == 0 && (image.imgPosition == 0)'
				 @click='goH5(image.url)'>
					<img v-lazy="image.img ? imgUrls+image.img :imgUrls+'main_prevention_gr.png'" />
				</van-swipe-item>
			</van-swipe>
		</aside>
		<section>
			<nav>
				<ul class='main_nav'>
					<li>
						<van-button @click='gonavgin("/quarters")'>
							<img :src="imgUrls+'main_prevention_1.png'" />
							<span>病例轨迹</span>
						</van-button>
					</li>
					<li>
						<van-button @click='gonavgin("/queryBus")'>
							<img :src="imgUrls+'main_prevention_2.png'" />
							<span>停运公交</span>
						</van-button>
					</li>
					<li>
						<van-button @click='gonavginH5(2)'>
							<img :src="imgUrls+'main_prevention_3.png'" />
							<span>同程查询</span>
						</van-button>
					</li>
					<li>
						<van-button @click='gonavgin("/fillIn")'>
							<img :src="imgUrls+'main_prevention_4.png'" />
							<span>返深申报</span>
						</van-button>
					</li>
					<li>
						<van-button @click='gonavgin("/Safety")'>
							<img :src="imgUrls+'main_prevention_5.png'" />
							<span>名师好课</span>
						</van-button>
					</li>
					<li>
						<van-button @click='gonavginH5(9)'>
							<img :src="imgUrls+'main_prevention_6.png'" />
							<span>谣言别跑</span>
						</van-button>
					</li>
					<li>
						<van-button @click='gonavginH5(1)'>
							<img :src="imgUrls+'main_prevention_7.png'" />
							<span>直达门诊</span>
						</van-button>
					</li>
					<li>
						<van-button @click='gonavgin("/hospitalization")'>
							<img :src="imgUrls+'main_prevention_8.png'" />
							<span>就医流程</span>
						</van-button>
					</li>
					<li>
						<van-button @click='gonavgin("/Viruses")'>
							<img :src="imgUrls+'main_prevention_9.png'" />
							<span>科普服务</span>
						</van-button>
					</li>
					<li>
						<van-button @click='goScroll'>
							<img :src="imgUrls+'main_prevention_10.png'" />
							<span>防护手册</span>
						</van-button>
					</li>
					<li v-show='isMoer'>
						<van-button @click='gonavgin("/doctorPeople")'>
							<img :src="imgUrls+'main_prevention_11.png'" />
							<span>免费课程</span>
						</van-button>
					</li>
					<li v-show='isMoer'>
						<van-button @click='gonavginH5(7)'>
							<img :src="imgUrls+'main_prevention_12.png'" />
							<span>应急一键明</span>
						</van-button>
					</li>
					<li v-show='isMoer'>
						<van-button @click='gonavgin("/scenicSpot")'>
							<img :src="imgUrls+'main_prevention_13.png'" />
							<span>免费景区</span>
						</van-button>
					</li>
					<li v-show='isMoer'>
						<van-button @click='gonavginH5(8)'>
							<img :src="imgUrls+'main_prevention_14.png'" />
							<span>房企战疫</span>
						</van-button>
					</li>
         <li v-show='isMoer'>
          	<van-button @click='gonavgin("/resumptionIndex")'>
          		<img :src="imgUrls+'main_prevention_15.png'" />
          		<span>社区防控</span>
          	</van-button>
          </li>
					<!-- 箭头
					<div :class='{main_prevention_icon:true,isRatete:isMoer}'>
						<van-button @click='goMoer'>
							<img :src="imgUrls+'main_prevention_jt.png'" />
						</van-button>
					</div> -->
				</ul>
			</nav>
		</section>

		<section class='section_main'>
			<nav class='sect_nav'>
				<div :class="{active:isSwitch}" @click='switchDiv(true)'>全国疫情信息</div>
				<div :class="{active:!isSwitch}" @click='switchDiv(false)'>{{city}}疫情信息</div>
			</nav>

			<div v-show='isSwitch'>
				<ul class='Ulflex'>
					<li>
						<p class='title_H4 span_D9' v-text="mapList.nationTotal && mapList.nationTotal.confirmedTotal || 0 ">447</p>
						<p class='p_'>确诊人数</p>
						<p>昨日<span class='span_D9' v-text="mapList.nationwideIncr && mapList.nationwideIncr.confirmedIncrStr || 0 ">+230</span></p>
					</li>
					<li>
						<p class='title_H4 span_F2' v-text="mapList.nationTotal && mapList.nationTotal.suspectedTotal || 0 ">447</p>
						<p class='p_'>疑似病例</p>
						<p>昨日<span class='span_F2' v-text="mapList.nationwideIncr && mapList.nationwideIncr.suspectedIncrStr || 0 ">+230</span></p>
					</li>
					<li>
						<p class='title_H4 span_22' v-text="mapList.nationTotal && mapList.nationTotal.deathsTotal || 0 ">447</p>
						<p class='p_'>死亡人数</p>
						<p>昨日<span class='span_22' v-text="mapList.nationwideIncr && mapList.nationwideIncr.deathsIncrStr || 0 ">+230</span></p>
					</li>
					<li>
						<p class='title_H4 span_C5' v-text="mapList.nationTotal && mapList.nationTotal.curesTotal || 0 ">447</p>
						<p class='p_'>治愈人数</p>
						<p>昨日<span class='span_C5' v-text="mapList.nationwideIncr && mapList.nationwideIncr.curesIncrStr || 0 ">+230</span></p>
					</li>
				</ul>
				<p class='p_time'>更新时间 {{mapList.updateTime | updateTime}}</p>
				<div class='main_Eachres'>
					<div id="myChartChina" class='myChartChina' :style="{width: '100%'}"></div>
				</div>
			</div>
			<div v-show='!isSwitch'>
				<ul class='Ulflex'>
					<li>
						<p class='title_H4 span_D9' v-text="cityObject.cityTotal.confirmedTotal">447</p>
						<p class='p_'>确诊人数</p>
					</li>
					<li>
						<p class='title_H4 span_22' v-text="cityObject.cityTotal.deathsTotal">447</p>
						<p class='p_'>死亡人数</p>
					</li>
					<li>
						<p class='title_H4 span_C5' v-text="cityObject.cityTotal.curesTotal">447</p>
						<p class='p_'>治愈人数</p>
					</li>
					<li>
						<p class='title_H4 span_F2' v-text="cityObject.cityIncr.confirmedIncr">447</p>
						<p class='p_'>新增人数</p>
					</li>
				</ul>
				<p class='p_time'>更新时间 {{mapList.updateTime | updateTime}}</p>
				<div class='main_Centent_'>
					<h5 class='Eachre_flex each_h5'>
						<div>市区</div>
						<div>确诊</div>
						<div>死亡</div>
						<div>治愈</div>
					</h5>
					<div class='Eachre_flex' v-for='(item , index) in cityList' :key='index'>
						<div v-text="item.name">南山区</div>
						<div v-text="item.confirmed_count >=0 ? item.confirmed_count : 0">38</div>
						<div v-text="item.death_count >=0 ? item.death_count : 0">97</div>
						<div v-text="item.cured_count >=0 ? item.cured_count : 0">2</div>
					</div>
					<div class='text_cen' v-if='cityList.length == 0'> 暂无该地区详情信息 </div>

				</div>
			</div>
		</section>

		<section class='main_Situation Statistics_img'>
			<div>
				<div class='sit_icon' v-show='Situation == item.eepId' v-for='(item,index) in imgMsgList' :key='index' v-if='item.eepId!=5'>
					<img :src="imgUrls+item.img" alt="">
				</div>
				<div class='flex btn_sit'>
					<van-button :class='{act_btn:Situation == 1}' @click='goSituation(1)'>
						全国疫情<br>新增趋势
					</van-button>
					<van-button :class='{act_btn:Situation == 2}' @click='goSituation(2)'>
						全国确诊<br>疑似/重症
					</van-button>
					<van-button :class='{act_btn:Situation == 3}' @click='goSituation(3)'>
						全国累计<br>治愈/死亡
					</van-button>
					<van-button :class='{act_btn:Situation == 4}' @click='goSituation(4)'>
						治愈率<br>病死率
					</van-button>
				</div>
			</div>
			<div class='img5_top'>
				<img :src="img5 ? imgUrls+ img5 : ''" alt="">
			</div>
		</section>

		<section class='main_section main_lists' v-if='false'>
			<h5 class='epidemic_h5' v-text='msgTitle'></h5>
			<van-tabs v-model="active" animated :ellipsis='false'>
				<van-tab v-for="(item,index) in msgList" :key='index' :title="item.subjectName">
					<div class='flex titleTrue' v-for="(ite , ind) in item.news" :key='ite.id' @click='goH5(ite.newsUrl)' v-if='ind < 4'>
						<div class='setions'>
							<h5 v-text="ite.title">新型病毒被命名为SARS-CoV-2</h5>
							<span>{{ite.publishTime | filtersTest}}</span>
						</div>
						<div>
							<img :src="ite.imgUrl[0]" alt="">
						</div>
					</div>
				</van-tab>
			</van-tabs>
			<div class='section_aside' @click='goH5("https://m.netwin.cn/netyun/special.html?subjectId=2776")'>
				<span>查看更多</span>
			</div>
		</section>

		<div class='preve'>
			<van-swipe class='vanSwipe' :autoplay="3000" indicator-color="white">
				<van-swipe-item v-for="(image, index) in imgList" :key="index" v-if='image.status == 0 && (image.imgPosition == 1)'
				 @click='goH5(image.url)'>
					<img v-lazy="image.img ? imgUrls+image.img : imgUrls+'main_prevention_gr.png'" />
				</van-swipe-item>
			</van-swipe>
		</div>

		<section class='main_section noneMar main_lists' v-if='false'>
			<h5 class='epidemic_h5' v-text='msgTitleTwo'>防控疫情 深圳行动</h5>
			<van-tabs v-model="activeTwo" animated :ellipsis='false'>
				<van-tab v-for="(item,index) in msgListTwo" :key='index' :title="item.subjectName">
					<div class='flex titleTrue' v-for="(ite , ind) in item.news" :key='ite.id' @click='goH5(ite.newsUrl)' v-if='ind < 4'>
						<div class='setions'>
							<h5 v-text="ite.title">新型病毒被命名为SARS-CoV-2</h5>
							<span>{{ite.publishTime | filtersTest}}</span>
						</div>
						<div>
							<img :src="ite.imgUrl[0]" alt="">
						</div>
					</div>
				</van-tab>
			</van-tabs>
			<div class='section_aside' @click='goH5("https://m.netwin.cn/netyun/special.html?subjectId=2790")'>
				<span>查看更多</span>
			</div>
		</section>

		<footer class='main_section noneMar' id='main_section_foot'>
			<h5 class='epidemic_h5'>防护知识</h5>
			<div class='flex flexCent'>
				<div @click='gonavgin("/protection")'> <img :src="imgUrls+'main_prevention_gr.png'" alt="">
					<span>个人防护知识</span>
				</div>
				<div @click='gonavgin("/homeProtection")'>
					<img :src="imgUrls+'main_prevention_home.png'" alt="">
					<span>居家防护知识</span>
				</div>
				<div @click='gonavgin("/workarea")'>
					<img :src="imgUrls+'main_prevention_work.png'" alt="">
					<span>工作区域防护知识</span>
				</div>
				<div @click='gonavginH5(5)'>
					<img :src="imgUrls+'main_prevention_fc.png'" alt="">
					<span>返程防护</span>
				</div>
			</div>
			<div class='koib_icon' @click='gonavgin("/maskDetail")'>
				<img :src="imgUrls+'main_prevention_kz.png'" alt="">
				<span>口罩鉴别</span>
			</div>
		</footer>
		<baidu-map v-show='false' class="map" @ready="handler" center="深圳" ak="EypwBGMe5ceMxIGGWqEydeXyzAnaPOMd">
		</baidu-map>
	</div>
</template>

<script>
	import util from '@/assets/js/util.js'
	import AreaList from '@/assets/js/city_code.js'
	import chinaJson from 'echarts/map/json/china.json'
	import {
		BaiduMap
	} from 'vue-baidu-map'

	let echarts = require('echarts/lib/echarts')
	require('echarts/lib/chart/map')
	// 引入提示框和title组件
	require('echarts/lib/component/tooltip')
	require('echarts/lib/component/title')
	require('echarts/lib/component/visualMap')
	require('echarts/lib/component/geo')
	echarts.registerMap('china', chinaJson)


	let dataTime = null; //当前时间错
	export default {
		name: '',
		data() {
			return {
				isadmin: true,
				isApp: false,
				imgUrls: this.$imgUrls,
				desc: this.$desc,
				isSwitch: true,
				Situation: 1,
				active: '',
				activeTwo: '',
				imgMsgList: [], //统计图
				msgList: [], //肺炎资训
				msgTitle: '', //标题
				msgListTwo: [], //防控资讯
				msgTitleTwo: '', //标题
				imgList: [],
				img5: null, //非湖北的对比图片
				mapList: {}, //中国地图数据
				clientHeight: 0,
				isMoer: true, //点击更多

				BMap: '',
				map: '',
				geolocation: null,
				city: '深圳市', //市区的名字
				checkCityCode: 440300, //市的code 默认深圳市
				cityList: [], //城市的数据
				cityObject: {
					cityTotal: {},
					cityIncr: {}
				}, //城市的数据
			}
		},
		components: {
			BaiduMap
		},
		created() {
			this.loaderBaner();
			this.loaderStatisticsList(); //统计图
			this.loader_F(); //新冠肺炎
			this.loaderFollow() //防控疫情
		},
		filters: {
			filtersTest(msgTime) {
				let timeDiffer = Math.abs(msgTime - dataTime);
				let returnTime = '';
				if (timeDiffer <= 60000) { //一分钟内
					returnTime = '1分钟前';
				} else if (timeDiffer > 60000 && timeDiffer < 3600000) { //1小时内
					returnTime = Math.floor(timeDiffer / 60000) + '分钟前';
				} else if (timeDiffer >= 3600000 && timeDiffer < 86400000) { //今日
					returnTime = Math.floor(timeDiffer / 3600000) + '小时前';
				} else if (timeDiffer > 86400000) { //昨天
					returnTime = Math.floor(timeDiffer / 86400000) + '天前'
				}
				return returnTime
			},
			updateTime(timeValue) {
				if (!timeValue) return '';
				let date = new Date(timeValue * 1000);
				let Y = date.getFullYear() + '/';
				let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/';
				let D = date.getDate() + ' ';
				let h = date.getHours() + ':';
				let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
				return Y + M + D + h + m;
			}
		},
		mounted() {
			let _this = this;
			// _this.isadmin = false;
			_this.$nextTick(function() {
				_this.goshare();
				_this.getMaplist();
				if (_this.$route.query.scroll) {
					window.scrollTo({
						top: 0,
						left: 0
					});
					// window.location.href = '#main_Top';
				}
				let setTime = setTimeout(() => {
					_this.$router.isDinwei = false
				}, 1500)
			})
		},
		methods: {
			async handler({
				BMap,
				map
			}) {
				let _this = this;
				_this.BMap = BMap;
				_this.map = map;
				_this.geolocation = new _this.BMap.Geolocation();
				_this.geolocation.enableSDKLocation();
				_this.dingwei();
			},
			async dingwei() {
				let _this = this;
				_this.geolocation.getCurrentPosition(function(r) {
					let zoom = 12;
					let mk = new _this.BMap.Marker(r.point);
					_this.map.setZoom(zoom)
					_this.map.addOverlay(mk); //标出所在地
					_this.map.panTo(r.point); //地图中心移动
					let point = new _this.BMap.Point(r.point.lng, r.point.lat); //用所定位的经纬度查找所在地省市街道等信息
					let gc = new _this.BMap.Geocoder();
					gc.getLocation(point, function(rs) {
						_this.city = rs.addressComponents.city;
						_this.setCity2(true);
					});
				}, function(e) {
					_this.allList();
				}, {
					enableHighAccuracy: true
				})
			},
			goMoer() {
				this.isMoer = !this.isMoer;
			},
			allList() {
				let _this = this;
				if (_this.checkCityCode == 440300) {
					_this.city = '深圳市'
				}
				_this.$axios.get('https://i.snssdk.com/toutiao/normandy/pneumonia_trending/district_stat/', {
						local_id: _this.checkCityCode
					}, true, true, true)
					.then(function(res) {
						_this.cityList = res.data.list;
						_this.cityload();
					})
			},
			cityload() {
				let _this = this;
				let url = _this.$api.ncov_data + `?data_type=[1]&city_code=["${_this.checkCityCode}"]`;
				_this.$axios.get(encodeURI(url), {}, true, true, true)
					.then(function(res) {
						_this.cityObject = res.ncov_city_data && JSON.parse(res.ncov_city_data[_this.checkCityCode])

					})
			},
			setCity2() {
				let _this = this;
				let datas2 = AreaList.city_list;
				for (let j in datas2) {
					if (datas2[j] == _this.city) {
						_this.checkCityCode = j;
						break;
					}
				}
				_this.allList();
			},
			goshare() {
				let _this = this;
				let urls = util.getUrl(`index.html`);
				if (util.hasNative()) {
					_this.isApp = true;
					_this.$dsBridge.dsShare({
						url: urls
					});
				}
			},
			loaderBaner() {
				let _this = this;
				_this.$axios.get(_this.$api.carouselList)
					.then(function(res) {
						_this.imgList = res;
					})
			},
			loaderStatisticsList() {
				let _this = this;
				_this.$axios.get(_this.$api.statisticsList)
					.then(function(res) {
						_this.imgMsgList = res;
						_this.imgMsgList.forEach((item, index) => {
							if (item.eepId == 5) {
								_this.img5 = item.img
							}
						})
					})
			},
			loaderFollow() { //肺炎的数据
				let _this = this;
				dataTime = (new Date()).valueOf();
				_this.$axios.get('https://api.netwin.cn/nayun-api//subject/subject/main/get/2776/index.json?time=' + dataTime)
					.then(function(res) {
						_this.msgTitle = res && res.subjectName;
						_this.msgList = res && res.childSubject;
					})
			},
			loader_F() { //关注
				let _this = this;
				dataTime = dataTime ? dataTime : (new Date()).valueOf();
				_this.$axios.get('https://api.netwin.cn/nayun-api//subject/subject/main/get/2790/index.json?time=' + dataTime)
					.then(function(res) {
						_this.msgTitleTwo = res && res.subjectName;
						_this.msgListTwo = res && res.childSubject;
					})
			},
			switchDiv(val) {
				this.isSwitch = val
			},
			goSituation(val) {
				this.Situation = val
			},
			goScroll() { //滚动到底部
				this.clientHeight = this.clientHeight || document.getElementsByClassName('main')[0].clientHeight;
				window.scrollTo({
					top: this.clientHeight,
					left: 0,
					behavior: 'smooth'
				});
				// window.location.href = '#main_section_foot';
			},
			goH5(val) {
				if (!val) {
					return
				}
				if(util.hasNative()){
					this.$dsBridge.dsCall(
					  'openOldNewsWebView',val 
					)
				}else{
					window.location.href = val;
				}
				
			},
			gonavgin(val) {
				if (!val) {
					return
				}
				this.$router.push(val)
			},
			gonavginH5(val) {
				let _this = this;
				if (val == 1) { //发热门诊
					try {
						_hmt.push(['_trackPageview', '/fare/index.html']);
            _hmts.push(['_trackPageview', '/fare/index.html']);
					} catch (e) {
						console.log('调用失败')
					}

					window.location.href = 'https://dc300.netwin.cn/fare/index.html';
				} else if (val == 2) { //同城查询
					try {
						_hmt.push(['_trackPageview', '/tongcheng/index.html']);
            _hmts.push(['_trackPageview', '/tongcheng/index.html']);
					} catch (e) {
						console.log('调用失败')
					}
					window.location.href = 'https://dc300.netwin.cn/tongcheng/index.html';
				} else if (val == 3) {
					this.$router.push('/maskDetail')

				} else if (val == 4) { //地图
					try {
						_hmt.push(['_trackPageview', '/yuqingditu/index.html']);
            _hmts.push(['_trackPageview', '/yuqingditu/index.html']);
					} catch (e) {
						console.log('调用失败')
					}
					window.location.href = 'https://dc300.netwin.cn/yuqingditu/index.html';
				} else if (val == 5) {
					try {
						_hmt.push(['_trackPageview', '/web/2020/02/37067745de3cf0d3a7aed87d66fea5d5.html']);
            _hmts.push(['_trackPageview', '/web/2020/02/37067745de3cf0d3a7aed87d66fea5d5.html']);
					} catch (e) {
						console.log('调用失败')
					}
					let url =
						'https://appdetail.netwin.cn/web/2020/02/37067745de3cf0d3a7aed87d66fea5d5.html?from=groupmessage&isappinstalled=0';
					if (_this.$dsBridge.dsHas('openDcPage')) {
						_this.$dsBridge.dsCall('openDcPage', {
							'url': url
						});
					} else {
						window.location.href = url
					}

				} else if (val == 6) {
					window.location.href =
						'https://dc300.netwin.cn/h5/fy/fyIndex';
				} else if (val == 7) {
					window.location.href =
						'https://dc300.netwin.cn/emer/';
				} else if (val == 8) {
					try {
						_hmt.push(['_trackPageview', 'netyun/special']);
            _hmts.push(['_trackPageview', 'netyun/special']);
					} catch (e) {
						console.log('调用失败')
					}
					let url = 'https://m.netwin.cn/netyun/special.html?subjectId=2837';
					if (_this.$dsBridge.dsHas('openDcPage')) {
						_this.$dsBridge.dsCall('openDcPage', {
							'url': url
						});
					} else {
						window.location.href = url
					}

				}else if(val == 9){
          try {
          	_hmt.push(['_trackPageview', 'yaoyan/index']);
            _hmts.push(['_trackPageview', 'yaoyan/index']);
          } catch (e) {
          	console.log('调用失败')
          }
          let url = 'http://2019ncov.gsdata.cn/oem/yaoyan/index.php?sign=94c397759a8e780d&from=groupmessage';
          if (_this.$dsBridge.dsHas('openDcPage')) {
          	_this.$dsBridge.dsCall('openDcPage', {
          		'url': url
          	});
          } else {
          	window.location.href = url
          }
        }
			},
			goBackMain() {
				if (this.isApp) {
					this.$dsBridge.dsCall('closeWin', '');
				}
			},

			//地图
			async getMaplist() {
				let _this = this;
				let datas = await _this.$axios.get(_this.$api.snssdkInfo, {
					activeWidget: 1,
					forum_id: 1656784762444839
				});
				this.mapList = JSON.parse(datas.forum.extra.ncov_string_list);
				this.drawMap(this.mapList.provinces);
			},
			// 地图
			drawMap(data) {
				var _this = this;
				data.forEach((item, n) => {
					data[n].value = data[n].confirmedNum
				})
				data.push({
					name: '南海诸岛',
					value: 999
				})
				// 基于准备好的dom，初始化echarts实例
				var myChartContainer = document.getElementById('myChartChina');
				var myChart = echarts.init(myChartContainer);
				var option = {
					tooltip: {
						triggerOn: "click",
						formatter: function(e, t, n) {
							if (e.name == '南海诸岛') {
								return
							}
							// return '省份: ' + e.name + "<br />" + '累计确诊: ' + e.data.confirmedNum
							return '省份: ' + e.name + "<br />" + '确诊: ' + e.data.confirmedNum + '<br />' + "死亡: " + e.data.deathsNum
						}
					},
					visualMap: {
						min: 0,
						left: 5,
						bottom: 0,
						showLabel: true,
						text: ["以上数字均来自官方通报", ""],
						itemWidth: 16,
						itemHeight: 8,
						itemGap: 4,
						inverse: true,
						textStyle: {
							color: '#222', //图例文字颜色，大小等配置
							fontSize: 8
						},
						pieces: [{
								gte: 1,
								lte: 9,
								label: "1-9人",
								color: "#fff7b9",
							}, {
								gte: 10,
								lte: 99,
								label: "10 - 99 人",
								color: "#ffc54f",
							}, {
								gte: 100,
								lt: 499,
								label: "100 - 499 人",
								color: "#f18334"
							}, {
								gte: 500,
								lte: 999,
								label: "500 - 999人",
								color: "#cc5f42"
							}, {
								gte: 1000,
								lte: 4999,
								label: "1000 - 4999人",
								color: "#aa4d37"
							},
							{
								gt: 5000,
								label: "5000人以上",
								color: "#792a18"
							}
						],
						show: true
					},
					geo: {
						map: "china",
						roam: false,
						scaleLimit: {
							min: 1,
							max: 2
						},
						zoom: 1.1,
						top: 30,
						left: 20,
						right: 20,
						label: {
							// 地图上省份字体的设置
							normal: {
								show: !0,
								fontSize: "8",
								color: "rgba(34,34,34,1)",
							}
						},
						// 地图中每个小版块的设置
						itemStyle: {
							normal: {
								borderColor: "rgba(0, 0, 0, 0.2)",
							},
							// 鼠标移入时候的设置
							emphasis: {
								areaColor: "#c1f4f7",
								shadowOffsetX: 0,
								shadowOffsetY: 0,
								borderWidth: 1
							}
						}
					},
					series: [{
						name: "疫情地图",
						type: "map",
						geoIndex: 0,
						data: data
					}]
				};
				myChart.setOption(option);
			}
		},
		updated() {
			this.clientHeight = document.getElementsByClassName('main')[0].clientHeight;
			if (this.$router.isDinwei) {
				this.goScroll()
			}
		}
	}
</script>

<style lang="scss" scoped>
	.flex {
		display: flex
	}

	.main {
		width: 10rem;
		min-height: 49rem;
		overflow-x: hidden;
		overflow-y: scroll;
		// height: 70.933333rem;
		margin: auto;
		background-image: myUrl('main_prevention_.png');
		background-color: #fff;
		background-size: 100% 15.933333rem;
		background-position: left top;
		background-repeat: no-repeat;
		position: relative;

		button {
			width: 100%;
			height: 100%;
			-webkit-tap-highlight-color: rgba(255, 255, 255, 0) !important;

			&:active,
			&:hover,
			&:link {
				-webkit-tap-highlight-color: rgba(255, 255, 255, 0) !important;
			}

			&::before {
				background-color: rgba(255, 255, 255, 0)
			}
		}



		.text_cen {
			text-align: center;
			padding: 0.266666rem 0;
		}

		.myChartChina {
			height: 8.5rem;
			position: relative;
		}

		.main_login {
			padding: 0.426666rem 0 0.253333rem 0.96rem;

			img {
				width: 2.533333rem;
				height: 0.72rem;
			}

			p {
				font-size: 0.533333rem;
				font-weight: 500;
				color: rgba(255, 255, 255, 1);
				line-height: 0.533333rem;
				margin-top: 0.133333rem;
			}
		}

		.aside_banner {
			width: 10rem;
			height: 4.093333rem;

			.vanSwipe,
			img {
				width: 100%;
				height: 100%;
			}
		}

		.img5_top {
			margin-top: 0.266666rem;
		}

		.main_nav {
			display: flex;
			flex-wrap: wrap;
			background-color: #fff;
			box-shadow: 0px -4px 20px 0px rgba(0, 0, 0, 0.14);
			border-radius: 0.133333rem;
			width: 8.266666rem;
			margin: auto;
			padding: 0.48rem 0.266666rem 0.266666rem 0.266666rem;
			margin-top: 0.266666rem;
			position: relative;

			li {
				width: 20%;
				text-align: center;
				padding-bottom: 0.56rem;
				cursor: pointer;

				span {
					display: block;
					font-size: 0.32rem;
					color: rgba(34, 34, 34, 1);
					line-height: 125%;
				}
			}

			img {
				width: 0.946666rem;
				height: 0.946666rem;
			}
		}

		.main_prevention_icon {
			position: absolute;
			width: 100%;
			height: 0.746666rem;
			bottom: 0;
			left: 0;
			cursor: pointer;

			button {
				width: 100%;
				height: 100%;
				text-align: center;
				display: flex;
				justify-content: center;
				align-items: center;

				img {
					width: 0.226666rem;
					height: 0.093333rem;
					margin: 0.266666rem;
				}
			}
		}

		.isRatete {
			img {
				transform: rotate(180deg);
			}
		}

		.Statistics_img {
			img {
				max-width: 100%;
			}
		}

		.main_lists {
			min-height: 13.28rem;
		}

		.section_main {
			width: 8.8rem;
			margin: auto;
			background: rgba(255, 255, 255, 1);
			box-shadow: 0px -4px 20px 0px rgba(0, 0, 0, 0.14);
			border-radius: 0.133333rem;
			margin-top: 0.266666rem;

			.sect_nav {
				font-size: 0.346666rem;
				display: flex;
				border-radius: 0.133333rem 0.133333rem 0 0;
				overflow: hidden;

				>div {
					cursor: pointer;
					flex: 1;
					text-align: center;
					color: rgba(153, 153, 153, 1);
					height: 0.933333rem;
					line-height: 0.933333rem;
					background-color: rgba(238, 239, 241, 1);
				}

				.active {
					background-color: #fff;
					color: rgba(34, 34, 34, 1);
				}
			}

			.Ulflex {
				display: flex;
				padding: 0 0.346666rem;
				padding-top: 0.6rem;

				>li {
					flex: 1;
					text-align: center;

					span {
						color: #000000;
						font-size: 0.293333rem;
					}
				}

				.title_H4 {
					font-size: 0.533333rem;
					font-weight: bold;
				}

				.p_ {
					width: 1.76rem;
					height: 0.533333rem;
					background: rgba(243, 243, 243, 1);
					border-radius: 0.133333rem;
					font-size: 0.293333rem;
					color: rgba(34, 34, 34, 1);
					margin: 0.213333rem auto;
					line-height: 0.533333rem;
				}

				.span_D9 {
					color: #D96421
				}

				.span_F2 {
					color: #F2A217
				}

				.span_22 {
					color: #222222;
				}

				.span_C5 {
					color: #38C4C5;
				}
			}

			.p_time {
				font-size: 0.293333rem;
				color: #999999;
				margin-top: 0.48rem;
				padding: 0 0.346666rem;
			}

			.main_Eachres {
				padding: 0.4rem 0.346666rem;
				// height: 6.266666rem;
			}

			.main_Centent_ {
				padding: 0.4rem 0.346666rem;

				.Eachre_flex {
					display: flex;
					border-bottom: 1px solid rgba(243, 243, 243, 1);
					line-height: 0.853333rem;
					font-size: 0.346666rem;
					color: #222222;

					>div:first-child {
						width: 49%;
					}

					>div:nth-child(2) {
						width: 17%;
						text-align: right;
					}

					>div:nth-child(3) {
						width: 17%;
						text-align: right;
					}

					>div:last-child {
						width: 17%;
						text-align: right;
					}

				}
			}

		}

		.main_Situation {
			width: 8.133333rem;
			margin: auto;
			padding: 0.266666rem 0.333333rem 0.266666rem 0.333333rem;
			background: rgba(255, 255, 255, 1);
			box-shadow: 0px -4px 20px 0px rgba(0, 0, 0, 0.14);
			border-radius: 0.133333rem;
			margin-top: 0.266666rem;

			.btn_sit {
				margin-top: 0.266666rem;

				button {
					flex: 1;
					width: 1.946666rem;
					height: 1.066666rem;
					line-height: 120%;
					letter-spacing: 0.026666rem;
					background: rgba(242, 242, 242, 1);
					border: 1px solid rgba(225, 225, 225, 1);
					border-radius: 0.106666rem;
					font-size: 0.293333rem;
					color: #222222;
					text-align: center;
					margin-right: 0.133333rem;
				}

				>button:last-child {
					margin-right: 0
				}

				.act_btn {
					background-color: rgba(222, 231, 252, 1);
					border: 1px solid rgba(178, 199, 252, 1);
					color: #1A53E5;
				}
			}
		}


		.main_section {
			background-color: #fff;
			margin-top: 0.4rem;

			.epidemic_h5 {
				color: #222222;
				font-size: 0.426666rem;
				font-weight: 400;
				height: 1.2rem;
				padding: 0 0.533333rem;
				line-height: 1.2rem;
				border-bottom: 1px solid rgba(234, 234, 234, 1);
			}
		}

		.titleTrue {
			flex: 1;
			border-bottom: 0.04rem solid #f8f8f8;
			height: 2.133333rem;
			padding: 0.266666rem 0.506666rem 0 0.506666rem;
			border-bottom: 1px solid rgba(234, 234, 234, 1);
			position: relative;

			h5 {
				font-size: 0.346666rem;
				line-height: 135%;
				color: #222222;
				font-weight: 400;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 3;
				-webkit-box-orient: vertical;
			}

			span {
				display: block;
				font-size: 0.293333rem;
				color: #999999;
				position: absolute;
				bottom: 0.266666rem;
				left: 0.666666rem
			}

			img {
				width: 3.2rem;
				height: 1.866666rem;
			}

			.setions {
				width: 5.6rem;
				padding: 0 0.373333rem 0 0.133333rem;
			}

		}

		.section_aside {
			font-size: 0.346666rem;
			height: 1.12rem;
			line-height: 1.12rem;
			border-bottom: 0.013333rem solid rgba(234, 234, 234, 1);
			text-align: center;
			color: #999999;
			cursor: pointer;

			span {
				text-decoration: underline;
				padding-bottom: 0.026666rem;
				display: inline-block;
			}
		}

		.preve {
			text-align: center;
			cursor: pointer;

			img {
				width: 9.466666rem;
				height: 4.093333rem;
			}

			padding: 0.266666rem 0;
		}

		.noneMar {
			margin-top: 0;
			border-top: 0.013333rem solid rgba(234, 234, 234, 1);
		}

		.flexCent {
			padding: 0.4rem 0.24rem 0 0.24rem;
			flex-wrap: wrap;

			div {
				width: 50%;
				text-align: center;
				position: relative;
				cursor: pointer;

				img {
					width: 4.666666rem;
					height: 2.666666rem;
				}

				span {
					cursor: pointer;
					display: block;
					position: absolute;
					left: 0;
					top: 0;
					bottom: 0;
					right: 0;
					text-align: center;
					line-height: 2.666666rem;
					color: #fff;
					font-size: 0.426666rem;
				}
			}
		}

		.koib_icon {
			text-align: center;
			position: relative;
			cursor: pointer;
			padding-bottom: 0.4rem;

			img {
				width: 9.466666rem;
				height: 2.666666rem
			}

			span {
				cursor: pointer;
				display: block;
				position: absolute;
				left: 0;
				top: 0;
				bottom: 0;
				right: 0;
				text-align: center;
				line-height: 2.666666rem;
				color: #fff;
				font-size: 0.426666rem;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/main.vue